import axios from 'axios';
const EXTERNAL_BNR_EXCHANGE_RATE = '/bnr/rates';

export const getExchageRateList = () => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}${EXTERNAL_BNR_EXCHANGE_RATE}`
  );
};
